import React from 'react';

// 페이지 컴포넌트 import
import Home from "../pages/Home";
import Profile from "../pages/Profile";
import Settings from "../pages/Settings";
import MenuManager from "../pages/MenuManager";
import UserRegister from "../pages/UserRegister";
import UserMenuAuthManager from "../pages/UserMenuAuthManager";
import MapView from "../pages/MapView";
import W_HR_R440 from "../pages/W_HR_R440";
import W_HR_R390 from "../pages/W_HR_R390";
import W_HR_R381 from "../pages/W_HR_R381";
import W_HR_R460 from "../pages/W_HR_R460";
import W_HR_R380 from "../pages/W_HR_R380";
import W_HR_R450 from "../pages/W_HR_R450";
import W_HR_R340 from "../pages/W_HR_R340";
import W_HR_R360 from "../pages/W_HR_R360";
import W_HR_R350 from "../pages/W_HR_R350";
import W_HR_R430 from "../pages/W_HR_R430";
import W_HR_R420 from "../pages/W_HR_R420";
import W_HR_R330 from "../pages/W_HR_R330";
import W_HR_R382 from "../pages/W_HR_R382";
import DeviMapBinReport from "../pages/DeviMapBinReport";
import WaferBinReport from "../pages/WaferBinReport"; //OLD PT
import PRBLotWaferView from "../pages/PRBLotWaferView";
import PTLotsummarybinReport from "../pages/PTLotsummarybinReport"; //PRB SBIN LOT SUMMARY 
import LotSummaryPage from "../pages/LotSummaryPage"; //2026-02-06 lot ,wafer summary 추가
import WaferSummaryPage from "../pages/WaferSummaryPage"; //2026-02-06 wafer summary 추가



import EQUIP_USE_REQ from "../pages/EQUIP_USE_REQ";
import LotWaferView from "../pages/LotWaferView";
import ChangePasswordPage from "../pages/ChangePasswordPage";
import UserAuthCopyManager from "../pages/UserAuthCopyManager";
import HardBinSummaryPage from "../pages/HardBinSummaryPage";
import SoftBinReportPage from "../pages/SoftBinReportPage";
import WipReceivingSummary from "../pages/WipReceivingSummary";
import WipShippingSummary from "../pages/WipShippingSummary";
import SoftBinReportDET from "../pages/SoftBinReportDET";
import AdminMenu from "../components/AdminMenu";
import PTSoftBinReportDET from "../pages/PTSoftBinReportDET";
import PTSoftBinReportPage from "../pages/PTSoftBinReportPage";
import FTHardBinYieldReport from "../pages/FTHardBinYieldReport";
import PTHardBinYieldReport from "../pages/PTHardBinYieldReport";
import RejectSummaryPage from "../pages/RejectSummaryPage";
import LisRejectSummaryPage from "../pages/LisRejectSummaryPage";
import WipReportByLotPage from "../pages/WipReportByLotPage";
import SmiWipReportPage from "../pages/SmiWipReportPage";
import WipReportByDatePage from "../pages/WipReportByDatePage";
import WipReportByDevicePage from "../pages/WipReportByDevicePage";
import LotHistoryPage from "../pages/LotHistoryPage";
import LotHistoryTrnxPage from "../pages/LotHistoryTrnxPage";
import InputLotListPage from "../pages/InputLotListPage";
import ShippingLotListPage from "../pages/ShippingLotListPage";
import ShippingMasterDetailPage from "../pages/ShippingMasterDetailPage";
import HoldLotListPage from "../pages/HoldLotListPage";
import BinDataSummaryPage from "../pages/BinDataSummaryPage";
import MonthlyInOutPage from "../pages/MonthlyInOutPage";
import LowYieldLotListPage from "../pages/LowYieldLotListPage";
import WipLotTatReportPage from "../pages/WipLotTatReportPage";
import SmiTestPgmReportPage from "../pages/SmiTestPgmReportPage";
import LoginHistoryPage from "../pages/LoginHistoryPage";




// --- ★★★ [수정] sidebarOpen, onToggleSidebar prop을 새로 받습니다. ★★★ ---
export default function TabContent({ tabs, selected, onSelect, onClose, onCloseAll, user, sidebarOpen, onToggleSidebar }) {


  const getComponentForTab = (tab) => {
    if (!tab || !tab.url) {
      return <Home />;
    }

    const componentMap = {
      "/home": <Home />,
      "/profile": <Profile user={user} />,
      "/settings": <Settings />,
      "/MenuManager": <MenuManager />,
      "/UserRegister": <UserRegister />,
      "/UserMenuAuthManager": <UserMenuAuthManager />,
      "/MapView": <MapView user={user} />,
      "/W_HR_R440": <W_HR_R440 user={user} />,
      "/W_HR_R390": <W_HR_R390 user={user} />,
      "/W_HR_R381": <W_HR_R381 user={user} />,
      "/W_HR_R460": <W_HR_R460 user={user} />,
      "/W_HR_R380": <W_HR_R380 user={user} />,
      "/W_HR_R450": <W_HR_R450 user={user} />,
      "/W_HR_R340": <W_HR_R340 user={user} />,
      "/W_HR_R360": <W_HR_R360 user={user} />,
      "/W_HR_R350": <W_HR_R350 user={user} />,
      "/W_HR_R430": <W_HR_R430 user={user} />,
      "/W_HR_R420": <W_HR_R420 user={user} />,
      "/W_HR_R330": <W_HR_R330 user={user} />,
      "/W_HR_R382": <W_HR_R382 user={user} />,
      "/DeviMapBinReport": <DeviMapBinReport user={user} />,
      "/WaferBinReport": <WaferBinReport user={user} />,
      "/PRBLotWaferView": <PRBLotWaferView user={user} />,
      "/PTLotsummarybinReport": <PTLotsummarybinReport user={user} />,
      "/LotSummaryPage": <LotSummaryPage user={user} />,
      "/WaferSummaryPage": <WaferSummaryPage user={user} />,
      

      "/EQUIP_USE_REQ": <EQUIP_USE_REQ user={user} />,
      "/LotWaferView": <LotWaferView user={user} />,
      "/ChangePasswordPage": <ChangePasswordPage user={user} />,
      "/UserAuthCopyManager": <UserAuthCopyManager user={user} />,
      "/HardBinSummaryPage": <HardBinSummaryPage user={user} />,
      "/SoftBinReportPage": <SoftBinReportPage user={user} />,
      "/WipReceivingSummary": <WipReceivingSummary user={user} />,
      "/WipShippingSummary": <WipShippingSummary user={user} />,
      "/SoftBinReportDET": <SoftBinReportDET user={user} />,
      "/AdminMenu": <AdminMenu />,
      "/PTSoftBinReportDET": <PTSoftBinReportDET user={user} />,
      "/PTSoftBinReportPage": <PTSoftBinReportPage user={user} />,
      "/FTHardBinYieldReport": <FTHardBinYieldReport user={user} />,
      "/PTHardBinYieldReport": <PTHardBinYieldReport user={user} />,
      "/RejectSummaryPage": <RejectSummaryPage user={user} />,
      "/LisRejectSummaryPage": <LisRejectSummaryPage user={user} />,
      "/WipReportByLotPage": <WipReportByLotPage user={user} />,
      "/SmiWipReportPage": <SmiWipReportPage user={user} />,
      "/WipReportByDatePage": <WipReportByDatePage user={user} />,
      "/WipReportByDevicePage": <WipReportByDevicePage user={user} />,
      "/LotHistoryPage": <LotHistoryPage user={user} />,
      "/LotHistoryTrnxPage": <LotHistoryTrnxPage user={user} />,
      "/InputLotListPage": <InputLotListPage user={user} />,
      "/ShippingLotListPage": <ShippingLotListPage user={user} />,
      "/ShippingMasterDetailPage": <ShippingMasterDetailPage user={user} />,
      "/HoldLotListPage": <HoldLotListPage user={user} />,
      "/BinDataSummaryPage": <BinDataSummaryPage user={user} />,
      "/MonthlyInOutPage": <MonthlyInOutPage user={user} />,
      "/LowYieldLotListPage": <LowYieldLotListPage user={user} />,
      "/WipLotTatReportPage": <WipLotTatReportPage user={user} />,
      "/SmiTestPgmReportPage": <SmiTestPgmReportPage user={user} />,
      "/LoginHistoryPage": <LoginHistoryPage />,
      
      
    };

    return componentMap[tab.url] || <div>"{tab.text}" 페이지를 찾을 수 없습니다.</div>;
  };

  return (
    <main style={{ 
        flex: 1, 
        display: "flex", 
        flexDirection: 'column', 
        overflow: 'hidden', 
        backgroundColor: '#f4f6f8' 
    }}>
      {/* 탭 바 UI */}
      <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          borderBottom: '1px solid #ddd', 
          backgroundColor: '#fff',
          paddingLeft: '10px', // 토글 버튼을 위한 공간
          flexShrink: 0,
      }}>
        {/* --- ★★★ [추가] 사이드바 토글 버튼 ★★★ --- */}
        <button
            onClick={onToggleSidebar}
            title={sidebarOpen ? "Hide Sidebar" : "Show Sidebar"}
            style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '20px',
                padding: '5px 10px',
                marginRight: '5px',
                borderRadius: '4px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
            {sidebarOpen ? '❮' : '❯'}
        </button>

        <div style={{
          flex: 1,
          display: 'flex', 
          alignItems: 'flex-end',
          overflowX: 'auto',
          paddingTop: '10px'
        }}>
          {tabs.map(tab => (
            <div
              key={tab.id}
              onClick={() => onSelect(tab)}
              style={{
                padding: '10px 15px',
                cursor: 'pointer',
                border: '1px solid #ddd',
                borderBottom: 'none',
                backgroundColor: selected?.id === tab.id ? '#f4f6f8' : '#e9ecef',
                borderTopLeftRadius: '6px',
                borderTopRightRadius: '6px',
                marginRight: '5px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                position: 'relative',
                bottom: '-1px',
                whiteSpace: 'nowrap'
              }}
            >
              <span>{tab.text}</span>
              {tab.url !== '/home' && (
                <span
                  onClick={(e) => { e.stopPropagation(); onClose(tab.id); }}
                  style={{ cursor: 'pointer', color: '#666' }}
                >×</span>
              )}
            </div>
          ))}
        </div>

        {tabs.length > 1 && (
            <button
                onClick={onCloseAll}
                style={{ 
                    marginLeft: '10px', 
                    marginRight: '15px',
                    padding: '5px 10px', 
                    border: '1px solid #ccc', 
                    borderRadius: '4px', 
                    background: '#f0f0f0', 
                    cursor: 'pointer', 
                    fontSize: '12px'
                }}
            >
                Close All
            </button>
        )}
      </div>
      
      {/* 페이지 콘텐츠 영역 */}
      <div style={{ flex: 1, position: 'relative' }}>
        {tabs.map(tab => (
          <div
            key={tab.id}
            style={{
              position: 'absolute',
              top: 0, left: 0,
              height: '100%', width: '100%',
              overflow: 'auto',
              padding: '20px',
              boxSizing: 'border-box',
              visibility: selected?.id === tab.id ? 'visible' : 'hidden',
            }}
          >
            {getComponentForTab(tab)}
          </div>
        ))}
      </div>
    </main>
  );
}